var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timeout},model:{value:(_vm.showSnackbar),callback:function ($$v) {_vm.showSnackbar=$$v},expression:"showSnackbar"}},[_vm._v(" "+_vm._s(_vm.message)+" "),_c('v-btn',{attrs:{"color":"accent","text":""},on:{"click":_vm.closeSnackbar}},[_vm._v(_vm._s(_vm.actionText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }